//document.getElementById('mini-cart').open = true;
let selectedBundleProduct = [];
let _ = {
  itemGridWrapper : 'product-list',
  productItems : 'product-item',
  cms_content : '#cms_content',
  atb_button : '[add-to-bundle-button]',
  bundleItems : '[data-bundle-items]',
  quantityWrapper : 'quantity-selector-bundle',
  bundleProductList : '[data-bundle-procuct-list]',
  progressWrapper : '.bundle-cart-actions--wrapper',
  bundleTotalPrice : '[data-total-price]',
  bundleCartWrapper : '[data-bundle-cart--wrapper]',
  bundleAddTocartButton : '[data-bundle-add-to-cart-button]'
}

window.bundle = {
  init : function(resetProducts = false){
    if(document.body.classList.contains('template--collection-bundle')){
      this.attachEvents();
      this.updateProgress();
      this.$$();
    }
    if(resetProducts == true){
      this.setFilteredProducts(this);
    }
  },
  setFilteredProducts : function($this){
    selectedBundleProduct.forEach(function(e){
      console.log(e)
      let productId = e.split('/')[0],
          qty = e.split('/')[1];
      let productGrid = $this.select(`[data-bundle-product="${productId}"]`);
      if(productGrid){
        productGrid.classList.add('item-added');
        let atb_button = productGrid.querySelector(_.atb_button),
            quantityWrapper = productGrid.querySelector(_.quantityWrapper),
            qtyInput = productGrid.querySelector('[data-product-qty-input]');
        qtyInput.value = qty;
        $this.attachAddToBudnle(atb_button,$this);
        $this.attachQtyActions(quantityWrapper,$this);
      }
    });
    $this.updateProgress();
  },
  drawerActions(productId,type){
    let selector = (type == 'drawer') ? 'quick-buy-drawer' : 'quick-buy-popover' ;
    let productGrid = this.select(`[data-bundle-product="${productId}"]`),
        drawer = productGrid.querySelector(selector),
        atb_button = drawer.querySelector(_.atb_button),
        quantityWrapper = drawer.querySelector(_.quantityWrapper),
        productJson = window.bundle.productContent(productGrid);
    if(!productJson['product']['available']){
      return;
    }
    quantityWrapper.querySelector('input[data-product-qty-input]').value = productGrid.querySelector(`.product-item__info input[data-product-qty-input]`).value; 
    this.attachAddToBudnle(atb_button,this);
    this.attachQtyActions(quantityWrapper,this);
    this.updateProgress();
  },
  $$ : function(){
    return {
      itemGrid : this.selectAll(`${_.itemGridWrapper} ${_.productItems}`),
      cms_content : JSON.parse(this.select(_.cms_content).innerText),
      atb_button : this.selectAll(_.atb_button),
      bundleItems : this.select(_.bundleItems),
      quantityWrapper : this.selectAll(_.quantityWrapper),
      progressWrapper : this.select(_.progressWrapper),
      bundleTotalPrice : this.select(_.bundleTotalPrice),
      bundleCartWrapper : this.select(_.bundleCartWrapper),
      bundleAddTocartButton : this.select(_.bundleAddTocartButton),
    }
  },
  selectAll(selector){
    return document.querySelectorAll(selector);
  },
  select(selector){
    return document.querySelector(selector);
  },
  getAddedProductData : function(){
//     console.log("=========================================================")
    let items = this.$$().bundleItems.querySelectorAll('[data-bundle-item]'),
        mainProductJson = this.mainProductContent(),
        mainProduct = {},
        itemArray = [],
        productTitlesArray = {},
        totalQuantity = 0,
        totalPrice = 0,
        currentTime = new Date().getTime(),
        $this =  this,
        tmpProducts = [],
        productDiscount = this.$$().cms_content.discount,
        tmpDiscount = productDiscount.discount,
        tmpDuration = productDiscount.discount_duration;

    mainProduct['id'] = mainProductJson.variants[0].id;
    mainProduct['quantity'] = 1;
    mainProduct['properties'] = productTitlesArray;
    mainProduct['properties']['_is_main_bundle'] = "true";
    
    items.forEach(function(e,i){
      if(!$this.select(`${_.bundleProductList} [data-bundle-product="${e.dataset.bundleItem}"]`)) return;
      let productData = window.bundle.productContent($this.select(`${_.bundleProductList} [data-bundle-product="${e.dataset.bundleItem}"]`)),
          procuctQty = e.querySelector('input[data-product-qty-input]').value,
          product = productData.product,
          tmpArray = {};
      console.log(productData)
      tmpArray['id'] = product.variants[0].id;
      tmpArray['quantity'] = Number(procuctQty);
      tmpArray['properties'] = {}
      tmpArray['properties']['_currentTime'] = currentTime;
      tmpArray['properties']['_is_bundle_item'] = "true";
      tmpArray['properties']['_quantity'] = Number(procuctQty);
      itemArray.push(tmpArray);
      totalPrice += (product.price * procuctQty);
      productTitlesArray[`product ${i + 1}`] = `${product.title} / ${procuctQty}`;
      productTitlesArray[`_mainCurrentTime`] = currentTime;
      totalQuantity += parseInt(procuctQty);
      tmpProducts.push(`${product.id}/${procuctQty}`);
      
    });
    
    itemArray.push(mainProduct);
    selectedBundleProduct = tmpProducts;
    
    /*if(productDiscount.enable_discount == true && 
       productDiscount.discount_duration != null && 
       productDiscount.enable_discount != null &&
       totalQuantity >= productDiscount.discount_duration){
      
      let calc = parseInt(totalQuantity / tmpDuration);
      let totalDescount = tmpDiscount * calc;
      let everyItemDiscount = totalDescount / totalQuantity;

      for(let k = 0; k < (itemArray.length - 1); k ++){
        let item = itemArray[k],
            itemDiscount = parseFloat((everyItemDiscount * item.quantity));
        item.properties['_discount'] = itemDiscount;
      }
      itemArray[itemArray.length - 1].properties['_discount'] = totalDescount;
      console.log(itemArray)
    }*/
    
    return {
      count: items.length,
      bundleItemsData : {
        'items': itemArray
      },
      allProductTitles : productTitlesArray,
      totalQuantity : totalQuantity,
      totalPrice : window.formatMoney(totalPrice),
      mainProduct : mainProduct
    }
  },
  productContent : function(element){
    return JSON.parse(element.querySelector('[data-product-content]').innerText);
  },
  mainProductContent : function(){
    return this.$$().cms_content.mainProduct;
  },
  cmsTotalProducts : function(){
    return this.$$().cms_content.totalProduct;
  },
  attachEvents : function(){
    this.$$().atb_button.forEach(element => this.attachAddToBudnle(element,this));
    this.$$().quantityWrapper.forEach(element => this.attachQtyActions(element,this));
    if(!this.$$().bundleAddTocartButton.classList.contains('listenerAdded')){
      this.$$().bundleAddTocartButton.classList.add('listenerAdded')
      this.$$().bundleAddTocartButton.addEventListener('click',element => this.actionAddtoCart(element,this))
    }
    
  },
  disableEnableButtons(actionDisable){
    this.$$().itemGrid.forEach(function(e){
      let atcButton = e.querySelector(_.atb_button),
          qtyPlusButton = e.querySelectorAll('.quantity-selector__button#plus_btn');
      if(actionDisable == true){
        atcButton.setAttribute('disabled',true);
        atcButton.classList.add('button--ternary');
        qtyPlusButton.forEach(function(e){
          e.setAttribute('disabled',true);
        });
      }
      if(actionDisable == false){
        atcButton.removeAttribute('disabled');
        atcButton.classList.remove('button--ternary');
        qtyPlusButton.forEach(function(e){
          e.removeAttribute('disabled');
        });
      }
    });
    this.$$().bundleItems.querySelectorAll('[data-bundle-item]').forEach(function(e){
      if(actionDisable == true){
        e.querySelector('.quantity-selector__button#plus_btn').setAttribute('disabled',true);
      }
      if(actionDisable == false){
        e.querySelector('.quantity-selector__button#plus_btn').removeAttribute('disabled',true);
      }
    })
  },
  updateProgress : function(){
    let cmsTotalQty = this.cmsTotalProducts(),
        cartTotalQty = this.getAddedProductData().totalQuantity,
        progress = (cartTotalQty * 100) / cmsTotalQty,
        remaining = (cartTotalQty < 5) ? 5 - cartTotalQty : cmsTotalQty - cartTotalQty,
        progressWrap = this.$$().progressWrapper,
        progressBar = progressWrap.querySelector('.progress_bg'),
        text = progressWrap.querySelector('.progress_text');
    
    if(cartTotalQty == 0){
      this.$$().bundleCartWrapper.classList.add('empty-bundle');
    }else{
      this.$$().bundleCartWrapper.classList.remove('empty-bundle');
    }
    
    if(progress <= 100){
      progressBar.style.width = `${progress}%`;
      if(cartTotalQty < 5){
        text.innerText = `${this.$$().cms_content.progress_text_5.replace('[count]',remaining)}`;
      }else{
        text.innerText = `${this.$$().cms_content.progress_text_10.replace('[count]',remaining)}`;
      }
    }

    function addStickyClassMObile(params){
      if(!params.matches){
        return;
      }
      if(cartTotalQty >= 5){
      document.body.classList.add('show-bundle-atc-button');
      }else{
        document.body.classList.remove('show-bundle-atc-button');
      }
    }
    let isMobile = window.matchMedia('screen and (max-width: 600px)');
    addStickyClassMObile(isMobile);
    isMobile.onchange = function (params) {
      addStickyClassMObile(params);
    }

    if(cartTotalQty >= 5){
      progressWrap.classList.add('show-atc-button');
    }else{
      progressWrap.classList.remove('show-atc-button');
    }
    
    if(remaining <= 0){
      progressWrap.classList.add('progress-full');
    }else{
      progressWrap.classList.remove('progress-full');
    }
    
    /*if(progress === 100){
      this.disableEnableButtons(true);
    }else{
      this.disableEnableButtons(false);
    }*/
    this.$$().bundleTotalPrice.innerText = this.getAddedProductData().totalPrice;
  },
  attachAddToBudnle :function(element,$this){
    if(element.classList.contains('listenerAdded') == true){
      return;
    }
    element.classList.add('listenerAdded');
    element.addEventListener('click',function(){
      let productItem = this.closest('product-item'),
          itemHtml = productItem.querySelector('bundle-item').innerHTML,
          productId = window.bundle.productContent($this.select(`${_.bundleProductList} [data-bundle-product="${this.dataset.productId}"]`)).product.id;
      productItem.classList.add('item-added');
      window.bundle.$$().bundleItems.insertAdjacentHTML('afterBegin',itemHtml);
      let bundle_item_qty_wrapper = window.bundle.$$().bundleItems.querySelector(`${_.bundleItems} [data-bundle-item="${productId}"] ${_.quantityWrapper}`);
      bundle_item_qty_wrapper.classList.remove('listenerAdded');
      window.bundle.attachQtyActions(bundle_item_qty_wrapper,$this);
      window.bundle.updateProgress();
      
    });
  },
  attachQtyActions : function(element,$this){
    if(element.classList.contains('listenerAdded') == true){
      return;
    }
    element.classList.add('listenerAdded');
    let qtyInput = element.querySelector('input'),
        qtyProuctId = qtyInput.dataset.productQtyInput;
    element.querySelectorAll('button').forEach(function(button){
      button.addEventListener('click',function(){
        let inputValue = qtyInput.value;
        if(this.classList.contains('action_plus')){
          inputValue++;
        }else{
          inputValue--;
        }
        if(inputValue == 0){
          $this.select(`${_.bundleItems} [data-bundle-item="${qtyProuctId}"]`).remove();
          $this.select(`${_.bundleProductList} [data-bundle-product="${qtyProuctId}"]`).classList.remove('item-added');
        }else{
          $this.selectAll(`[data-product-qty-input="${qtyProuctId}"]`).forEach(function(e){
            e.value = inputValue;
          });
        }
        window.bundle.updateProgress();
      });
    });
  },
  resetBundle(){
    var selectedProducts = this.selectAll(`${_.itemGridWrapper} ${_.productItems}.item-added`);
    selectedProducts.forEach(function(e){
      e.classList.remove('item-added');
      e.querySelector(`[data-product-qty-input][name="quantity"]`).value = 1;
    });
    this.$$().bundleCartWrapper.classList.add('empty-bundle');
    this.$$().bundleItems.innerHTML = "";
//     this.disableEnableButtons(false);
    selectedBundleProduct = [];
  },
  actionAddtoCart(element,$this){
    let bundleItems = this.getAddedProductData().bundleItemsData,
        button = element.currentTarget;
    
    button.setAttribute('aria-busy',true)
    
    fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: JSON.stringify(bundleItems),
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": 'application/json'
      }
    })
    .then(resp => {
      return resp.json();
    })
    .then((data) => {
      $this.refreshCart($this,button,true)
    });
    
  },
  refreshCart : function($this,button = null,showCart = false,quantity = null,lineItem = null){
    console.log("refreshCart :: ",quantity);
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async function(response2) {
      const cartContent = await response2.json();
      
      if(lineItem != null){
        lineItem.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
      }
      
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: true,
          replacementDelay: quantity === 0 ? 1000 : 600
        }
      }));

      if(showCart == true){
        this.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true
        }));
      }
      if(button != null){
        button.setAttribute('aria-busy',false);
        $this.resetBundle();
      }
    });
  },
  cartActions : function(element){
    let lineItem = element.closest('line-item'),
        itemsJson = JSON.parse(lineItem.querySelector('[bundle-items-json]').innerHTML),
        action = element.dataset.action,
        $this = this;
    
    this.makeCartItemLoader(lineItem,false);
    
    if(action == "minus"){
      itemsJson[0].quantity = (itemsJson[0].quantity - 1);
    }
    if(action == "plus"){
      itemsJson[0].quantity = (itemsJson[0].quantity + 1);
    }
    if(action == "remove"){
      for(let x in itemsJson){
        itemsJson[x].quantity = 0;
      }
    }
    let newProductProperties = [];
    for(let i = 0; i < itemsJson.length; i++){
      if(itemsJson[i].product_title){
        if(itemsJson[0].quantity == 1){
          itemsJson[i].quantity = itemsJson[i].properties._quantity;
        }else{
          itemsJson[i].quantity = (itemsJson[i].properties._quantity * itemsJson[0].quantity)
        }
        newProductProperties.push(`${itemsJson[i].product_title} / ${itemsJson[i].quantity}`)
        delete itemsJson[i]['product_title'];
        delete itemsJson[i]['main_quantity'];
      }
    }
    for(let k in newProductProperties){
      itemsJson[0].properties[`product ${(Number(k) + 1)}`] = newProductProperties[k];
    }
    
    for(let x in itemsJson){
      if(itemsJson[x].quantity == 0){
        delete itemsJson[x]['properties'];
      }
    }
    
    lineItem.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: true, detail: { newLineQuantity: itemsJson[0].quantity } }));
    
    this.updateCartItem(itemsJson).then(function(){
      window.bundle.makeCartItemLoader(lineItem,true).then(function(){
        window.bundle.refreshCart($this,null,false,itemsJson[0].quantity,lineItem);
      });
    });
  },
  updateCartItem : async function(items){
    for(let i = 0; i < items.length; i++){
      let response = await fetch(window.themeVariables.routes.cartChangeUrl+'.js', {
        body: JSON.stringify(items[i]),
        method: "POST",
        headers: {
          "Content-Type": 'application/json'
        }
      });
      let responceJson = response.json();
        console.log(responceJson);
    }
  },
  makeCartItemLoader : async function (lineItem,finishLoading){ 
    let itemLoader = lineItem.querySelectorAll('.line-item__loader');
    for(let k = 0; k < itemLoader.length; k++){
      let loader = itemLoader[k];
      loader.hidden = false;
      if(finishLoading == false){
        loader.firstElementChild.hidden = false;
        loader.lastElementChild.hidden = true;
      }
      if(finishLoading == true){
        loader.firstElementChild.hidden = true;
        loader.lastElementChild.hidden = false;
        await loader.lastElementChild.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 75, endDelay: 300 }).finished;
        loader.hidden = true;
      }
    }
  }
  
};

window.bundle.init();